/**
 * Copyright © 2025 Delicious AI, LLC
 */

import { gql } from '@apollo/client'

import { INVITATION_FRAGMENT } from '../fragments'

export const RESEND_INVITATION = gql`
  mutation ResendInvitation($invitationId: ID!) {
    resendInvitation(invitationId: $invitationId) {
      ...Invitation
    }
  }
  ${INVITATION_FRAGMENT}
`
